import React, { Component } from "react";
import { Button, Modal, PageHeader, FormGroup, InputGroup, FormControl, ListGroupItem } from "react-bootstrap";
import { FontAwesomeIcon }           from '@fortawesome/react-fontawesome'
import LoaderButton                  from "../../components/LoaderButton";
import { Link, Routes }            from 'react-router-dom'
import YouTubeThumbnail            from "../../components/YouTubeThumbnail";
import ModalYouTubeVideo           from "../../components/modal/ModalYouTubeVideo";
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import SortDropdownBasicMenu       from "../../components/utils/SortDropdownBasicMenu";
import AddDropdownBasicMenu        from "../../components/utils/AddDropdownBasicMenu";
import RenderLander                from "../../components/utils/RenderLander";
import uniqueId                    from 'lodash/uniqueId';
import { Colors }                  from "../../utils/Colors";
import { invokeGetSearchExercisesListAll, invokeGetExercisesListAll, invokeSetDeleteExercise } from "../../utils/AwsInvoke";
import "../../css/exercise/ExerciseList.css";
import "../../css/modal/ModalBasics.css";
import checkmark_green from '../../images/utils/checkmark_green.png';
import checkmark_gray  from '../../images/utils/checkmark_gray.png';

// uuidv1() = timestamp | uuidv4() = rnadom
const uuidv1 = require('uuid/v1');

export default class ExerciseList extends Component {
    constructor(props) {
        super(props);

        var search_term = `${this.props.match.params.search_term}`;
        if(search_term === "&") search_term = "";

        this.state = {
              isLoading: false, // default is true
              numberOfRows: 100,
              sortBy: 1, // default sort by Name Asc
              searchMsg: "",
              searchTerm: search_term,
              showLoadingBar:"none",
              pageOverlay: "none",
              showDeleteConfirmWin: false
        };
    }

    componentDidMount() {
        var that = this;
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            this.getExerciseList();
        } catch (e) {
            alert(e);
        }
    }

    getExerciseList = async event => {
        this.setState({
            showLoadingBar: "inline",
            showDeleteConfirmWin: false
        })

        //// If user searched for an exercise and then hits the back button,
        //// take the user back to the search results page with the search term
        var search_term = this.state.searchTerm;
        var sort_by     = this.state.sortBy;
        var number_of_rows = this.state.numberOfRows;
        // SortBy: name ASC, 2: name DESC, 3: date ASC, 4: date DESC
        if(search_term != "" && search_term != "&") {
            this.searchExercises(number_of_rows, sort_by); // search for existing keyword
        } else {
            const results = await invokeGetExercisesListAll(number_of_rows, sort_by);

            if(results) {
                this.setState({
                    exercises: results,
                    isLoading: false,
                    showLoadingBar: "none",
                    showDeleteConfirmWin: false,
                    searchMsg: "There are "+results.search_lgth+ " exercises.",
                });
            } else
                this.setState({
                    showLoadingBar: "none",
                    showDeleteConfirmWin: false,
                    isLoading: false
                })
        }
    }

    clearSearchField = () => {
        // RESET URL
        this.props.history.replace("/exercise/listAll/&")

        this.setState({
            searchTerm: "", // reset search term if resetting exerc list
            searchMsg: ""
        }, function () {
            this.getExerciseList(); // reload list after deleting search term
        })
    }

    searchExercises = async (number_of_rows, sort_by) => {
        var search_term = this.state.searchTerm;

        if(this.searchInput != undefined) {
            search_term = this.searchInput.value;

            if(search_term.length === 0) search_term = "&";

            this.props.history.replace("/exercise/listAll/"+search_term)

            //// RESET Search Textfield
            if(search_term === "&") {
                this.setState({
                    searchTerm: "", // reset search term if resetting exerc list
                    searchMsg: ""   // clear search message
                }, function () {
                    this.getExerciseList();
                })
                return
            }
        }

        const results = await invokeGetSearchExercisesListAll(search_term.toLowerCase(), number_of_rows, sort_by);

        if(results) {
            this.setState({
                exercises: results,
                searchTerm: search_term,
                searchMsg: "You have "+results.search_lgth+ " results when searching for '" + search_term + "'.",
                isLoading: false,
                showLoadingBar: "none"
            });
        } else {
            this.setState({
                isLoading: false,
                showLoadingBar: "none"
            });
        }
    }


    handleCloseYouTubeWin = () => {
        this.setState({
            showYouTubeModal: false
        });
    }

    showYouTubeVideoModal = (event, yt_id, exercise_name) => {

        this.setState({
            youTubeId: yt_id,
            pageOverlay: "inline",
            showYouTubeModal: true,
            exercise_name: exercise_name
        })
    }

    sortResults = (sort) => {
        this.setState({
            sortBy: sort,
            exercises: null // reset exercises object otherwise the exercises list will re-render multiple times
        }, function(){
            this.getExerciseList();
        })
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.searchExercises();
    }

    renderExercisesList(exercises) {

          var search_msg     = "";
          var tmp_search_msg = this.state.searchMsg;

          search_msg = <div key={uniqueId()} className="exerciseHeaderButtons">
                            <span style={{position:"relative", top:"7px", left:"7px", fonySize: "19px"}}>
                             { tmp_search_msg }
                            </span>

                            <span className="pull-right">
                                <SortDropdownBasicMenu sortResults={this.sortResults.bind(this)} />
                            </span>
                       </div>

            if(exercises != null) {
                  return [{}].concat(exercises.name).map(
                    (exercise, i) =>
                      i !== 0 ?
                              <div key={uniqueId()} className="grid exerciseListGrid">
                                    <span className="exerciseListRowLeft">
                                            <span className="exerciseListSingleRowThumb">
                                                <span onClick ={(e) => this.showYouTubeVideoModal(e, exercises.yt_id[i-1], exercise)}>
                                                      <YouTubeThumbnail yt_id={exercises.yt_id[i-1]} width={100} />
                                                </span>
                                            </span>
                                    </span>
                                    <span   className="exerciseListRowMiddle"
                                            href= {"/exercise/details/"+exercises.id[i-1]}
                                            onClick={this.handleAddExercise.bind(this)}>
                                          <span className="exerciseListSingleRow">
                                                  { i }. { exercise }
                                          </span>
                                          <div>
                                              { exercises.completed[i-1] === "true" ?
                                                  <span className="exerciseListAllCheckmark" >
                                                      <img src={checkmark_green} width="20" height="20" />
                                                      <span className="exerciseListExercDateAdded">Added: { (new Date(exercises.date[i-1])).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) }</span>
                                                  </span>
                                                :
                                                  <span className="exerciseListAllCheckmark" >
                                                      <img src={checkmark_gray} width="20" height="20" />
                                                      <span className="exerciseListExercDateAdded">Added: { (new Date(exercises.date[i-1])).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) }</span>
                                                  </span>
                                              }
                                          </div>
                                    </span>
                                    <span className="exerciseListRowRight" style={{float:"right",zIndex:1000,backgroundColor: "transparent"}}>
                                            <span className="exerciseListSingleRowSm pullRight"
                                                  onClick={(e) => this.handleDeleteExercise(e, exercises.id[i-1])}>
                                                <span className="glyphicon glyphicon-remove-circle glyphiconDeleteExercBtn"
                                                      style = {{color: Colors.delete_button_bg}}/>
                                            </span>
                                    </span>
                            </div>

                            :
                            <span key={uniqueId()} >
                                <div className="exerciseHeaderSearchBar">
                                    <span>
                                        <FormGroup>
                                           <InputGroup>
                                             <FormControl key = {uniqueId()}
                                                          type="text"
                                                          placeholder=""
                                                          defaultValue={this.state.searchTerm}
                                                          inputRef={ref => { this.searchInput = ref; }}
                                                          onKeyPress={this.handleKeyPress}
                                                      />

                                               <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                                     onClick={() => this.clearSearchField()}
                                               />
                                               <InputGroup.Button>
                                                    <Button style={{ display:"inline-block", height:"34px", backgroundColor: Colors.search_button_bg, color:"white", borderRadiusInputTopRight: "5px" }}
                                                         onClick={() => this.searchExercises()}>
                                                         Search
                                                     </Button>
                                               </InputGroup.Button>
                                           </InputGroup>
                                         </FormGroup>
                                     </span>
                                 </div>
                              { search_msg }

                              { i === 0 && Object.keys(exercises).length < 1 ?
                                    <ListGroupItem style={{height:400}}>
                                        <br/>
                                        You currently have 0 exercises.
                                    </ListGroupItem>

                                : null }
                          </span>
                  );
             }
    }

    handleAddExercise = event => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    handleDeleteExercise = async (event, exercise_id) => {
        event.preventDefault();

        this.setState({
            pageOverlay: "inline",
            showDeleteConfirmWin: true,
            exerciseId: exercise_id
        });

        /*
        //// Function below works great in browser but not on a mobile browser;
        //// if you click an exercise detail, then hit the back btn in the
        //// browser, the onClick handler stops firing and the exercise no longer
        //// deletes
        Do not use native JS confirmation boxes, they have problems in mobile safari after pressing the back button!
        const confirmed = window.confirm(
            "Are you sure you want to delete this exercise?"
        );
        if (!confirmed) return;*/
    }

    //// Temp solution for mobile browser back button issue described above;
    //// works great but having issues with the popup confirm box
    /*handleNewDeleteExercise = event => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }*/

    getNext100Results = () => {
        var tmp_rows = this.state.numberOfRows;
        tmp_rows = tmp_rows + 100;

        this.setState({
            numberOfRows: tmp_rows
        }, function(){
            this.getExerciseList();
        })
    }

    renderPrograms() {
        var next_100;

        if(!this.state.isLoading)
            next_100 = <span style={{display:"inline-block", width:"100%", textAlign:"center", fontSize:"18px", cursor:"pointer"}} onClick={() => this.getNext100Results()}> Next 100 results >> </span>

        if(this.state.searchMsg != "") next_100 = ""; // if user is searching for an exercise, hide "next 100 results" msg

        return (
              <div className="programs">
                <PageHeader>
                            <FontAwesomeIcon icon="dumbbell" style={{ position:"relative", top:5, fontSize: '1.3em', color: Colors.primary_color, paddingRight:"16px" }}/>
                            Exercises
                            <AddDropdownBasicMenu handleProgram = {() => this.handleAddExercise.bind(this)} />

                </PageHeader>
                <div>
                    {!this.state.isLoading && this.renderExercisesList(this.state.exercises)}
                </div>
                <br/>
                { next_100 }
                <br/><br/><br/><br/>
              </div>
        );
    }

    async deleteExercise () {
        this.setState({ isLoading: true /*pageOverlay: "none", showDeleteConfirmWin: false*/ });

        var results = await invokeSetDeleteExercise(this.state.exerciseId);

        if(results.status)
            this.getExerciseList();
        else
            this.getExerciseList();
    }

    handleCloseWin = (action) => {
        if(action === "delete") this.deleteExercise();
            else this.setState({ pageOverlay: "none", showDeleteConfirmWin: false });
    }


    render() {

        return (
              <div className="ProgramList">
                {this.props.isAuthenticated ? this.renderPrograms() : <RenderLander />}

                <FooterLoadingBar text={"Retieving Exercises ..."}
                                  showLoadingBar={this.state.showLoadingBar}/>
                  {this.state.showYouTubeModal ?
                      <ModalYouTubeVideo
                          pageOverlay      = {this.state.pageOverlay}
                          showYouTubeModal = {this.state.showYouTubeModal}
                          exercise_name    = {this.state.exercise_name}
                          youTubeId        = {this.state.youTubeId}
                          closeYouTubeWin  = {this.handleCloseYouTubeWin}
                          showSummary      = {false}
                          />
                  : null}
                  <div>
                        <span className="pageOVerlay" style={{display:this.state.pageOverlay}}></span>
                        <Modal
                               show            = {this.state.showDeleteConfirmWin}
                               onHide          = {() => this.handleCloseWin("close")}
                               size            = "lg"
                               centered        = "true"
                               aria-labelledby = "contained-modal-title"
                               className       = "modalBasics"
                             >
                               <Modal.Header closeButton>
                                   <Modal.Title id="contained-modal-title">
                                       <FontAwesomeIcon icon="info-circle" className="modalAlertIcon" />
                                       <span className="modalBasicsTitle">
                                           Confirm Exercise Deletion
                                       </span>
                                   </Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                                   <span className="modalAlertBody">
                                   Are you sure you want to delete this exercise?
                                    </span>
                               </Modal.Body>
                               <Modal.Footer>
                                       <Button className="modalBasicsBtnClose" onClick={() => this.handleCloseWin("close")}>Cancel</Button>
                                       <span className="modalBasicsFooterXPosSpacer"/>
                                       <LoaderButton
                                           bsSize    = "large"
                                           //disabled  = {!this.validateForm()}
                                           //type      = "submit"
                                           btncolor  = { Colors.delete_button_dark_red_bg }
                                           height    = {38}
                                           width     = {125}
                                           isLoading = {this.state.isLoading}
                                           text        = "Yes, Delete"
                                           loadingText = "" //"Deleting program…"
                                           onClick     = {() => this.handleCloseWin("delete")}
                                         />
                               </Modal.Footer>
                         </Modal>
                  </div>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/exercise/ExerciseList.js